import reusableModule from './reusableModule';
import { registerStore, unRegisterStore } from './helpers';

export const unRegisterMixin = {
  destroyed() {
    unRegisterStore(this.$store, this.moduleName || 'moduleGenerated');
    sessionStorage.removeItem(this.moduleName || 'moduleGenerated');
  },
};

export default {
  data() {
    //config variables
    return {
      //change value in method created of component
      shouldRecovery: true,
      shouldUseSessionStorage: true,
      moduleName: 'moduleGenerated', // you can change name module in implementation component
    };
  },
  computed: {
    moduleData() {
      return this.$store.state[this.moduleName].data;
    },
  },
  watch: {
    storeGeneratorMixinCreated: {
      handler() {
        const {
          namespacedHelpers: { mapMutations },
        } = registerStore(this.$store, this.moduleName, reusableModule, false);
        let mutations = mapMutations(['setStateDynamicModule']);
        // set mutations in methods
        this['setStateDynamicModule'] = mutations.setStateDynamicModule;
      },
      immediate: true,
    },
  },
  created() {
    window.addEventListener('beforeunload', this.registerDestroyOnRefresh);
  },
  beforeMount() {
    this.recoveryData();
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.registerDestroyOnRefresh);
  },
  methods: {
    registerDestroyOnRefresh() {
      this.$destroy();
    },
    recoveryData() {
      let data =
        this.$store.state[this.moduleName].data[this.$options.name] ||
        (JSON.parse(sessionStorage.getItem(this.moduleName)) || {})[
          this.$options.name
        ];

      if (this.shouldRecovery && data) {
        let models = Object.keys(data);
        let dataWithoutReference = { ...data };

        models.forEach((model) => {
          this[model] = dataWithoutReference[model];
        });
      }
    },
    persistLazyData(toSave) {
      const data = {
        ...this.$store.state[this.moduleName].data,
        ...toSave,
      };

      this.setStateDynamicModule(data);

      if (this.shouldUseSessionStorage)
        sessionStorage.setItem(this.moduleName, JSON.stringify(toSave));
    },
    persistData(args = [], exclude = false) {
      let toSave = {};

      if (args.length == 0) toSave = this.$data;
      else {
        if (exclude) {
          Object.keys(this.$data).forEach((property) => {
            if (!args.includes(property)) {
              toSave[property] = this[property];
            }
          });
        } else {
          args.forEach((arg) => {
            toSave[arg] = this[arg];
          });
        }
      }

      this.persistLazyData({
        [this.$options.name]: toSave,
      });
    },
  },
};
